import { SchemaWithClient } from '../types/SchemaWithClient';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import { Client } from '../services/Client';
import { DateField } from '../components/Table/fields/DateField';
import { SPDateField } from '../components/Table/fields/SPDateField';

export const crazyGroup: SchemaWithClient<any> = {
  name: 'Crazy Group',
  pluralName: 'Crazy Groups',
  showDeleted: true,
  hasSum: true,
  columns: {
    organizer: {
      name: 'Group',
      readOnly: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    arrival_date: {
      name: 'Arrival Date',
      readOnly: true,
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
    },
    departure_date: {
      name: 'Departure Date',
      readOnly: true,
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
    },
    participants_count: {
      name: 'Size',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
    phone_number: {
      name: 'Phone Number',
      readOnly: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    groom_name: {
      name: 'Stag Name',
      readOnly: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    entity: {
      name: 'Entity',
      readOnly: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    flight_informations: {
      name: 'Flight Info',
      readOnly: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    accommodation_informations: {
      name: 'Accom Info',
      readOnly: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    seller_name: {
      name: 'Seller Name',
      readOnly: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    seller_phone: {
      name: 'Seller Phone',
      readOnly: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    id: {
      name: 'ID',
      readOnly: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
  },
  client: new Client('/crazy-groups'),
  viewTable: 'crazy-groups',
  isViewTable: true,
};
